/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect, useState } from "react";
import ParamsContext from "../context/ParamsContext";
import productService from "../services/productService";
import { useWrapperContext } from "../context/WrapperContext";
import NoDataPlaceholder from "./NoDataPlaceholder";
import Loading from "./loading/Loading";
import Chips from "./Chips";
import { BOTTOM_VIEW } from "../services/constant";
import { X, ShoppingBag } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const ProductDetails = ({ setBottomView }) => {
  const { setProductDetails, productDetails } = useContext(ParamsContext);
  const { shopifyRedirectUrl } = useWrapperContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const onError = useCallback((data) => {
    console.log(data, "error");
    setError(true);
  }, []);

  // const onSuccess = useCallback((data)=>{
  //   console.log(data,"success");
  // },[])

  const handleProductDetails = useCallback(async () => {
    setError(false);
    try {
      const res = await productService.handleProductUrlParse(
        "https://www2.hm.com/en_in/productpage.1292498002.html"
      );
      setLoading(false);
      if (res?.data?.errorCode) {
        // handlePosthog({
        //   productUrl: productUrl || productLink,
        //   status: "error",
        //   type: "metadata",
        //   eventName: "/url-parsing",
        //   payload: {data:JSON.stringify({ ...selectedProduct, errorMessage: handleErrorMessage(res?.data) })},
        // });
        onError(res?.data);
        return;
      }
      setProductDetails(res?.data);
      // setLoading(true);
      // handlePosthog({ productUrl: productUrl || productLink, status: "success", type: "metadata", eventName: "/url-parsing", payload: {data:JSON.stringify({ ...selectedProduct, data: res?.data })} });
      // productService.handleWebsocketProductImageCheck({
      // 	openTryonId: res?.data?.openTryonId,
      // 	onSuccess: (data) => {
      // 		// handlePosthog({ productUrl: productUrl || productLink, status: "success", type: "websocket", eventName: "/url-parsing", payload: {data:JSON.stringify({ ...selectedProduct, data:data })} });
      // 		onSuccess(data);
      // 	},
      // 	onError: (data) => {
      // 		// handlePosthog({
      // 		// 	productUrl: productUrl || productLink,
      // 		// 	status: "error",
      // 		// 	type: "websocket",
      // 		// 	eventName: "/url-parsing",
      // 		// 	payload: {data:JSON.stringify({ ...selectedProduct, errorMessage: handleErrorMessage(data) })},
      // 		// });
      // 		onError(data);
      // 	},
      // 	onOpen: () => {
      // 		// handlePosthog({ productUrl: productUrl || productLink, status: "open", type: "websocket", eventName: "/url-parsing" });
      // 	},
      // 	// onClose: () => handlePosthog({ productUrl: productUrl || productLink, status: "close", type: "websocket", eventName: "/url-parsing" }),
      // });
      // setProductDetails(res?.data);
    } catch (err) {
      onError(err);
    }
  }, [onError, setProductDetails]);

  useEffect(() => {
    if (!productDetails && shopifyRedirectUrl) {
      handleProductDetails();
    } else {
      setLoading(false);
    }
  }, []);
  const { theme } = useTheme();
  return loading ? (
    <div className="flex items-center justify-center w-full h-full"><Loading
    height="auto"
    width="auto" isAnimation /></div>
  ) : (
    <>
      {productDetails && !error ? (
        <div className="h-full overflow-y-auto pr-4 [&::-webkit-scrollbar]:w-1
  [&::-webkit-scrollbar-track]:bg-gray-100
  [&::-webkit-scrollbar-thumb]:bg-gray-300
  dark:[&::-webkit-scrollbar-track]:bg-neutral-700
  dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500">
          <div className="text-[16px] font-medium pr-[30px]">
            {productDetails?.searchResults?.[0]?.title}
          </div>
          <button
            className={`absolute top-2 right-2 p-1.5 rounded-full transition-colors duration-200 w-[24px] h-[24px] flex items-center justify-center ${
              theme === "light"
                ? "bg-gray-100 text-gray-500 hover:text-gray-900 hover:bg-gray-200"
                : "bg-gray-800 text-gray-400 hover:text-gray-100 hover:bg-gray-700"
            }`}
            onClick={() => setBottomView(BOTTOM_VIEW.NONE)}
          >
            <X className="w-[100%] block" />
          </button>

          <div className="flex align-center gap-2 py-3">
            <Chips text={productDetails?.searchResults?.[0]?.brand} />
            <button
              className={`px-3 py-1 rounded-full text-[14px] font-medium flex items-center transition-colors duration-200 gap-1 h-[25px] ${
                theme === "light"
                  ? "bg-gray-900 text-white hover:bg-gray-800"
                  : "bg-gray-100 text-gray-900 hover:bg-white"
              }`}
            >
              <ShoppingBag className="w-[13px]" />
              Buy
            </button>
          </div>
          <p
            className={`text-[14px]  ${
              theme === "light" ? "text-gray-600" : "text-gray-300"
            }`}
          >
            {productDetails?.searchResults?.[0]?.description}
          </p>
        </div>
      ) : (
        <NoDataPlaceholder />
      )}
    </>
  );
};

export default ProductDetails;
